import React from 'react';
import parse from 'html-react-parser';
import { Link } from 'react-router-dom';

export default function Hero({
  title,
  subTitle,
  bgUrl,
  imgUrl,
  infoList,
  btnText2,
  btnUrl2,
}) {
  return (
    <section className="cs_hero cs_style_1">
      <div
        className="cs_hero_wrap cs_bg_filed"
        style={{ backgroundImage: `url(${bgUrl})` }}
      >
        <div className="container">
          <div className="cs_hero_text">
            <h1 className="cs_hero_title cs_fs_94">{parse(title)}</h1>
            <p className="cs_hero_subtitle cs_fs_20 cs_heading_color">
              {parse(subTitle)}
            </p>
          </div>
          <img src={imgUrl} alt="Hero" className="cs_hero_img" />
          <div className="cs_hero_info_wrap cs_shadow_1 cs_white_bg cs_radius_15">
            {infoList.map((item, index) => (
              <div className="cs_hero_info_col" key={index}>
                <div className="cs_hero_info d-flex align-items-center">
                  <div className="cs_hero_info_icon cs_center rounded-circle cs_accent_bg">
                    <img src={item.iconUrl} alt="Icon" />
                  </div>
                  <div className="cs_hero_info_right">
                    <h3 className="cs_hero_info_title cs_semibold">
                      {item.title}
                    </h3>
                    {item.type === 'phone' ? (
                      <a
                        href={`tel:${item.subTitle}`}
                        className="cs_hero_info_subtitle cs_fs_20"
                      >
                        {item.subTitle}
                      </a>
                    ) : item.type === 'address' ? (
                      <>
                        <a
                          href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                            `${item.subTitle}, ${item.subTitle2}`
                          )}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="cs_hero_info_subtitle cs_fs_20"
                        >
                          {item.subTitle}
                        </a>
                        <br />
                        <a
                          href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                            `${item.subTitle}, ${item.subTitle2}`
                          )}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="cs_hero_info_subtitle cs_fs_20"
                        >
                          {item.subTitle2}
                        </a>
                      </>
                    ) : item.type === 'address-multiple' ? (
                      <>
                        {[item.subTitle, item.subTitle2].map((address, i) => (
                          <div key={i}>
                            <a
                              href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="cs_hero_info_subtitle cs_fs_20"
                            >
                              {address}
                            </a>
                          </div>
                        ))}
                      </>
                    ) : item.type === 'locations' ? (
                      <>
                        {item.locations.map((location, i) => (
                          <div key={i}>
                            <a
                              href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                                location.address
                              )}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="cs_hero_info_subtitle cs_fs_20"
                            >
                              {location.label}
                            </a>
                          </div>
                        ))}
                      </>
                    ) : (
                      <p className="cs_hero_info_subtitle cs_fs_20">
                        {item.subTitle}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            ))}
            <div className="cs_hero_info_col">
              <Link to={btnUrl2} className="cs_btn cs_style_1">
                <span>{btnText2}</span>
                <i>
                  <img src="/images/icons/arrow_white.svg" alt="Icon" />
                  <img src="/images/icons/arrow_white.svg" alt="Icon" />
                </i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
